import { getAdditionalUserInfo, OAuthProvider } from "firebase/auth";

export const saveProfessionalSession = (data) => {
  if (!data?.accessToken || !data?._id) return false;

  localStorage.removeItem("clientToken");
  localStorage.removeItem("clientData");
  localStorage.removeItem("clientId");
  localStorage.setItem("professionalToken", data.accessToken);
  localStorage.setItem("professionalId", data._id);
  localStorage.setItem("professionalData", JSON.stringify(data));
  return true;
};

export const getProfessionalPostSocialLoginPath = (profileSteps) => {
  if (profileSteps === 4 || profileSteps === 1) {
    return "/professional/dashboard";
  }
  return "/professional/signup";
};

export const splitDisplayName = (displayName = "") => {
  const parts = String(displayName).trim().split(/\s+/).filter(Boolean);
  return {
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" ") || "",
  };
};

export const createAppleAuthProvider = () => {
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  return provider;
};

export const getAppleAuthProfile = (result) => {
  const user = result?.user;
  if (!user) return null;

  const additional = getAdditionalUserInfo(result);
  const appleProfile = additional?.profile;
  let firstName = "";
  let lastName = "";

  if (appleProfile?.name) {
    firstName = appleProfile.name.firstName || "";
    lastName = appleProfile.name.lastName || "";
  } else {
    const split = splitDisplayName(user.displayName);
    firstName = split.firstName;
    lastName = split.lastName;
  }

  return {
    email: user.email || appleProfile?.email || "",
    appleId: user.uid,
    firstName,
    lastName,
  };
};

export const shouldFallbackToAppleRedirect = (error) =>
  ["auth/popup-blocked", "auth/cancelled-popup-request"].includes(error?.code);

export const getGoogleAuthProfile = (result) => {
  const user = result?.user;
  if (!user) return null;

  const googleProvider = user.providerData?.find(
    (providerData) => providerData.providerId === "google.com",
  );
  const { firstName, lastName } = splitDisplayName(
    user.displayName || googleProvider?.displayName || "",
  );

  return {
    email: user.email || googleProvider?.email || "",
    googleId: googleProvider?.uid || user.providerData?.[0]?.uid || user.uid,
    profileImage: user.photoURL || googleProvider?.photoURL || "",
    firstName,
    lastName,
  };
};

export const getAppleSignInErrorMessage = (error) => {
  if (
    error?.code === "auth/invalid-api-key" ||
    error?.message?.includes("api-key-not-valid")
  ) {
    return "Firebase API key is invalid. Update REACT_APP_FIREBASE_PRO_API_KEY in .env or enable Apple Sign-In on the main Firebase project.";
  }
  if (error?.code === "auth/operation-not-allowed") {
    return "Apple Sign-In is not enabled in Firebase. Enable the Apple provider under Authentication → Sign-in method.";
  }
  if (error?.code === "auth/unauthorized-domain") {
    return "This domain is not authorized for Apple Sign-In in Firebase.";
  }
  if (error?.code === "auth/popup-blocked") {
    return "Please enable popups for this website.";
  }
  return error?.message || "Apple login failed";
};
